module.exports = __webpack_public_path__ + "static/media/ahkaneti_resume.5d57002c.pdf";